module.exports = __webpack_public_path__ + "static/media/logo1.cba1a583.png";